<template>
  <div class="subpage">
    <h1 class="subpage__headline">
      Polityka prywatności
    </h1>
    <div class="subpage__content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-xl-10 mx-auto">
            <br /><br />
            Fundacja Greenpeace Polska popiera fundamentalne prawo każdego
            człowieka do zachowania prywatności w internecie. Robimy wszystko,
            co tylko możliwe, aby ochronić bezpieczeństwo danych użytkowników
            naszych serwisów internetowych oraz wszystkich osób, które
            przekazują nam swoje dane.
            <br /><br />
            1. Administratorem danych osobowych zbieranych na niniejszej stronie
            internetowej jest Fundacja Greenpeace Polska z siedzibą w Warszawie,
            przy ulicy Altowej 4, 02-386 Warszawa („Greenpeace”), telefon: 22
            851 26 42, e-mail: e-mail: spl@greenpeace.org.
            <br /><br />
            2 .Fundacja powołała inspektora ochrony danych, z którym można się
            skontaktować poprzez email ido.pl@greenpeace.org lub pisemnie na
            adres siedziby Fundacji.
            <br /><br />
            3. Greenpeace chroni dane osobowe zgodnie z wymogami powszechnie
            obowiązujących przepisów prawa, w tym Rozporządzenia Parlamentu
            Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r.
            (RODO).
            <br /><br />
            4. Opisane zasady odnoszą się do wszystkich stron administrowanych
            przez Greenpeace. Nie mają zastosowania do stron innych organizacji,
            do których możemy umieszczać linki i których zasady ochrony danych
            osobowych mogą różnić się od naszych.
            <br /><br />
            5. Nie zbieramy informacji, które pozwolą na identyfikację naszych
            użytkowników, chyba że dobrowolnie zdecydowali się oni na ich
            udostępnienie przez stronę, e-mail, telefon, poprzez dołączenie się
            do grona naszych darczyńców, podpisanie petycji lub wzięcie udziału
            w rekrutacji. Jeśli już zdecydowałeś/aś się udostępnić nam te
            informacje, zapewniamy ich pełną poufność.
            <br /><br />
            6. Dane osobowe, które zbieramy od Ciebie, gdy chcesz nam przekazać
            darowiznę to: Twoje imię, nazwisko, adres e-mail, telefon,
            miejscowość, kod pocztowy, ulica, nr budynku/lokalu, data urodzenia,
            numer karty płatniczej, kod CVV, miesiąc ważności karty, rok
            ważności karty.
            <br /><br />
            7. Dane osobowe, które zbieramy od Ciebie, gdy chcesz przyłączyć się
            do naszej petycji to: Twoje imię, nazwisko, adres e-mail, kod
            pocztowy (w Polsce) lub inny kraj zamieszkania.
            <br /><br />
            8. Dane osobowe, które zbieramy od Ciebie, gdy chcesz zamówić usługę
            Newslettera to: Twoje imię, adres e-mail, województwo.
            <br /><br />
            9. Jeżeli przetwarzanie udostępnionych nam danych wymaga udziału
            trzeciej strony (np. banku), korzystamy z najwyższej jakości usług
            zapewniających maksymalne bezpieczeństwo danych.
            <br /><br />
            10. Podczas podawania swoich danych osobowych na naszej stronie
            internetowej zawsze będziesz mógł zapoznać się z klauzulą
            informacyjną w której szczegółowo poinformujemy Cię o zasadach
            przetwarzania Twoich danych osobowych.
            <br /><br />
            11. Nie sprzedajemy, nie wynajmujemy, ani nie udostępniamy w żaden
            inny sposób naszych list mailingowych, w tym pozyskanych przez tę
            stronę, ani żadnych innych informacji, które mogą posłużyć do
            zidentyfikowania danych osobowych.
            <br /><br />
            12. Greenpeace nie dzieli się ani w żaden inny sposób nie udostępnia
            swoich danych innym organizacjom. Możemy jednak dzielić się
            informacjami pomiędzy narodowymi lub regionalnymi biurami
            Greenpeace, w celu efektywnego informowania o naszych kampaniach i
            mobilizowania opinii publicznej, aby osiągać cele naszych kampanii
            oraz pozyskiwać fundusze niezbędne do finansowania naszej
            działalności.
            <br /><br />
            13. Nie udostępniamy danych użytkowników zewnętrznym agencjom w
            innym celu, niż związany z realizowanymi przez nas projektami i
            tylko wówczas, gdy zapewniają przestrzeganie przepisów o ochronie
            danych osobowych.
            <br /><br />
            14. Dostęp do danych osobowych (tylko w niezbędnym zakresie) – będą
            mieć wyłącznie upoważnieni pracownicy Fundacji, podmioty, którym
            Fundacja powierzyła przetwarzanie danych osobowych na podstawie
            zawartych umów, podmioty świadczące usługi doradczo-kontrolne,
            podmioty przetwarzające dane w celu prowadzenia zastępstwa
            procesowego, oraz podmioty wchodzące w skład struktur
            organizacyjnych Fundacji, poza granicami Polski – jedynie w celach i
            w zakresie niezbędnym do realizacji przez Fundację wskazanych
            powyżej celów.
            <br /><br />
            15. Dane osobowe mogą być przekazywane do odbiorców znajdujących się
            w państwach poza Europejskim Obszarem Gospodarczym (operatorzy
            systemu obsługujący pocztę email Administratora – Kanada i USA).
            Przetwarzając dane osobowe korzystamy również z narzędzi
            analitycznych takich jak Facebook Analytics i Google Analytics, co
            może wiązać się z przekazaniem danych osobowych do państwa spoza
            Europejskiego Obszaru Gospodarczego (USA). Poza Europejski Obszar
            Gospodarczy do państw, w stosunku do których Komisja nie stwierdziła
            odpowiedniego stopnia ochrony, dane osobowe są przekazywane na
            podstawie standardowych klauzul ochrony danych przyjętych przez
            organ nadzoru i zatwierdzonych przez Komisję. Podmioty, do których
            przesyłamy dane osobowe, gwarantują odpowiednie ich zabezpieczenie.
            Masz możliwość uzyskania kopii tych danych.
            <br /><br />
            16. Jeżeli wyraziłeś/wyraziłaś na to zgodę lub wsparłeś, którąś z
            naszych petycji będziesz mógł/mogła brać udział w naszych przyszłych
            kampaniach, otrzymywać informacje o naszych działaniach albo zostać
            zaproszonym do finansowego wspierania Greenpeace. Udzieloną zgodę
            możesz zawsze wycofać, możesz także zgłosić sprzeciw, jeżeli
            podstawą przetwarzania Twoich danych osobowych jest uzasadniony
            interes administratora.
            <br /><br />
            17. Informacje o naszych działaniach możesz również otrzymywać drogą
            mailową jeżeli zamówiłeś usługę Newslettera. Zawsze możesz
            zrezygnować z otrzymywania tych informacji – pod każdym newsletterem
            znajduje się link do zrezygnowania z otrzymywania kolejnej
            korespondencji.
            <br /><br />
            18. Rejestrujemy także niektóre informacje od osób, które nawiązały
            z nami kontakt po to, aby otrzymać od nas informacje albo z prośbą o
            pomoc, po to, aby móc udzielić informacji albo oczekiwanej pomocy.
            Nie przekazujemy tych informacji nikomu innemu (chyba, że udzielisz
            nam na to zgody), ani nie używamy tych informacji do innych celów.
            <br /><br />
            19. Nasze strony internetowe znajdują się na kilku serwerach.
            Informacje w logach naszych stron nie umożliwiają personalnej
            identyfikacji, nie staramy się także połączyć tych informacji z
            rzeczywistymi osobami, które przeglądają nasze strony. Nasz serwer
            zbiera informacje na temat daty i czasu odwiedzin na naszej stronie,
            a także adresu serwera z którego dana osoba wchodzi na naszą stronę.
            Możemy także zapisywać informacje (anonimowo) o ruchach, które
            użytkownicy wykonują na naszych stronach. Wykorzystujemy te
            informacje do poprawy jakości naszej strony i oceny statystyk,
            takich jak pory dnia i dni tygodnia, podczas których panuje wzmożony
            ruch na naszych stronach, a także do oceny popularności różnych
            działów.
            <br /><br />
            20. Strona rewolucyjna.pl używa technologii cookies, aby
            zapewnić użytkownikom strony wygodę korzystania z serwisu oraz
            lepsze dopasowanie treści do preferencji. Cookie to niewielki plik
            tekstowy przechowywany na Twoim komputerze lub urządzeniu mobilnym w
            trakcie Twojej wizyty na stronie. Za każdym razem, kiedy za pomocą
            Twojej przeglądarki będziesz odwiedzać stronę ponownie, cookies
            połączą się z serwerem, na którym znajduje się strona (jeśli
            wyrazisz na to zgodę w ustawieniach Twojej przeglądarki). Oto
            rodzaje cookies, które wykorzystujemy na naszej stronie:
            <br /><br />
            <ul>
              <li>
                Niezbędne: niezbędne pliki cookie mają kluczowe znaczenie dla
                podstawowych funkcji witryny i witryna nie będzie działać w
                zamierzony sposób bez nich.
              </li>
              <li>
                Funkcjonalne: funkcjonalne pliki cookie pomagają wykonywać pewne
                funkcje, takie jak udostępnianie zawartości witryny na
                platformach mediów społecznościowych, zbieranie informacji
                zwrotnych i inne funkcje stron trzecich.
              </li>
              <li>
                Analityczne: analityczne pliki cookie służą do zrozumienia, w
                jaki sposób użytkownicy wchodzą w interakcję z witryną.
              </li>
              <li>
                Wydajnościowe: wydajnościowe pliki cookie służą do zrozumienia i
                analizy kluczowych wskaźników wydajności witryny, co pomaga
                zapewnić lepsze wrażenia użytkownika dla odwiedzających.
              </li>
              <li>
                Reklamowe: reklamowe pliki cookie służą do dostarczania
                użytkownikom spersonalizowanych reklam w oparciu o strony, które
                odwiedzili wcześniej, oraz do analizowania skuteczności kampanii
                reklamowej.
              </li>
            </ul>
            <br /><br />
            21. Masz prawo: dostępu do danych (art. 15 RODO), otrzymania kopii
            danych (art. 15 ust. 3 RODO), sprostowania (art. 16 RODO), usunięcia
            danych (art. 17 RODO), ograniczenia przetwarzania (art. 18 RODO),
            przenoszenia danych (art. 20 RODO), sprzeciwu (art. 21 RODO) oraz do
            cofnięcia zgody w przypadkach przewidzianych prawem. Cofnąć zgodę
            możesz w każdym momencie i bez podawania przyczyny, lecz
            przetwarzanie danych osobowych dokonane przed cofnięciem zgody nadal
            pozostanie zgodne z prawem.
            <br /><br />
            22. Jeżeli uznasz, że przetwarzanie Twoich danych przez Greenpeace
            jest niezgodne z prawem, możesz wnieść skargę do organu nadzorczego
            (Prezes Urzędu Ochrony Danych Osobowych).
            <br /><br />
            23. Greenpeace zastrzega sobie prawo zmiany tej Polityki
            prywatności, w szczególności w przypadku konieczności jej
            dostosowania do aktualnych przepisów prawa, zmiany sposobu
            przetwarzania danych lub wprowadzenia nowych wymogów organów
            nadzorczych. Zmiany, o których mowa w zdaniu poprzednim, nie
            ograniczają praw nabytych przed wejściem zmian w życie.
            <br /><br />
            24. Niniejsza Polityka prywatności obowiązuje od 11 lutego 2019 r.
            <br /><br />
            25. O treści zmian Polityki prywatności Greenpeace poinformuje
            poprzez umieszczenie stosownej informacji na stronie internetowej:
            https://greenpeace.pl. Taka informacja będzie utrzymana na wskazanej
            stronie przez okres co najmniej 15 (piętnastu) kolejnych dni
            kalendarzowych.
            <br /><br />
            <h2>Cookies</h2>
            <br />
            Strona rewolucyjna.pl używa technologii cookies, aby zapewnić
            użytkownikom strony wygodę korzystania z serwisu oraz lepsze
            dopasowanie treści do preferencji. Cookie to niewielki plik tekstowy
            przechowywany na Twoim komputerze lub urządzeniu mobilnym w trakcie
            Twojej wizyty na stronie. Za każdym razem, kiedy za pomocą Twojej
            przeglądarki będziesz odwiedzać stronę ponownie, cookies połączą się
            z serwerem, na którym znajduje się strona (jeśli wyrazisz na to
            zgodę w ustawieniach Twojej przeglądarki). Oto rodzaje cookies,
            które wykorzystujemy na naszej stronie:
            <br /><br />
            Niezbędne<br />
            Niezbędne pliki cookie mają kluczowe znaczenie dla podstawowych
            funkcji witryny i witryna nie będzie działać w zamierzony sposób bez
            nich.
            <br /><br />
            Funkcjonalne<br />
            Funkcjonalne pliki cookie pomagają wykonywać pewne funkcje, takie
            jak udostępnianie zawartości witryny na platformach mediów
            społecznościowych, zbieranie informacji zwrotnych i inne funkcje
            stron trzecich.
            <br /><br />
            Analityczne<br />
            Analityczne pliki cookie służą do zrozumienia, w jaki sposób
            użytkownicy wchodzą w interakcję z witryną.
            <br /><br />
            Wydajnościowe<br />
            Wydajnościowe pliki cookie służą do zrozumienia i analizy kluczowych
            wskaźników wydajności witryny, co pomaga zapewnić lepsze wrażenia
            użytkownika dla odwiedzających.
            <br /><br />
            Reklamowe<br />
            Reklamowe pliki cookie służą do dostarczania użytkownikom
            spersonalizowanych reklam w oparciu o strony, które odwiedzili
            wcześniej, oraz do analizowania skuteczności kampanii reklamowej.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Privacy",
  title: "Polityka prywatności",
  data() {
    return {
      title: "Privacy page",
    };
  },
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      const width = window.innerWidth;
      let heightOfForm = document.getElementById("form__wrapper").scrollHeight;
      if (width > 768) {
        window.scroll({
          top: 0,
          left: 0,
        });
      } else {
        window.scroll({
          top: heightOfForm,
          left: 0,
        });
      }
    },
  },
};
</script>
